import './index.scss';
import destiny_spinner from '../../assets/destiny_spinner.svg';

interface Props {
  translatedMsg: string;
}
function Loading({ translatedMsg }: Props) {
  return (
    <div data-testid="loading-spinner" className="loading__container">
      <div className="loading__content">
        <div className="loading__spinner_image">
          <img className="loading__image" src={destiny_spinner} alt="loading" />
        </div>
        <p className="loading__text">{translatedMsg}</p>
      </div>
    </div>
  );
}

Loading.defaultProps = {
  translatedMsg: 'Loading ...',
};

export default Loading;
